import { Box, Typography } from '@mui/material';
import { HAIRLINE } from '../colors';
import { FORMS_GRID_COLUMNS } from './tabTableLayout';
import { FormRowContent, FormRowStatus } from './formRowContent';

interface Props {
  content: FormRowContent;
  onView: () => void;
  onResend: () => void;
}

const STATUS_COLOR: Record<FormRowStatus['kind'], string> = {
  signed: 'success.main',
  awaiting: 'primary.main',
};

const STATUS_LABEL: Record<FormRowStatus['kind'], string> = {
  signed: 'Signed',
  awaiting: 'Awaiting signature',
};

function FormTableRow({ content, onView, onResend }: Props) {
  const isSigned = content.status.kind === 'signed';

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', sm: FORMS_GRID_COLUMNS },
        columnGap: '20px',
        rowGap: { xs: '6px', sm: 0 },
        alignItems: 'center',
        padding: '18px 0',
        borderBottom: `1px solid ${HAIRLINE}`,
      }}>
      <Box>
        <Typography variant="h4" sx={{ color: 'text.primary' }}>
          {content.name}
        </Typography>
        <Typography
          variant="body2"
          sx={{ color: 'text.secondary', marginTop: '5px' }}>
          {content.subline}
        </Typography>
      </Box>
      <Typography
        variant="h5"
        sx={{ color: STATUS_COLOR[content.status.kind] }}>
        {STATUS_LABEL[content.status.kind]}
      </Typography>
      <Box
        component="button"
        type="button"
        onClick={isSigned ? onView : onResend}
        sx={{
          background: 'none',
          border: 'none',
          padding: 0,
          color: 'primary.main',
          cursor: 'pointer',
          textAlign: { xs: 'left', sm: 'right' },
          typography: 'h5',
          fontWeight: 700,
        }}>
        {isSigned ? 'View' : 'Resend'}
      </Box>
    </Box>
  );
}

export default FormTableRow;
